import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';

import { Loader } from '@crehana/ui/';

import PaymentWithSavedCard from 'Jsx/CheckoutV4/components/PaymentWithSavedCard';
import { DegreeQuota } from 'Jsx/CheckoutV4/types';

import useStripeV2Lib from 'Jsx/CheckoutV4/shared/hooks/useStripeV2Lib';

import useSavedCards from 'Jsx/Shared/Hooks/useSavedCards';

import CheckoutForm from './CheckoutForm';

const Stripe = ({
  symbol,
  quotas,
  selectedQuotaNumber,
  setSelectedQuotaNumber,
  isDesktop,
  isStripeMexico,
}: {
  symbol: string | null;
  quotas?: DegreeQuota[];
  selectedQuotaNumber: number;
  setSelectedQuotaNumber: Dispatch<SetStateAction<number>>;
  isDesktop?: boolean;
  isStripeMexico: boolean;
}) => {
  const { isLoadingStripeLib } = useStripeV2Lib();

  const {
    savedCards,
    loading: loadingSavedCard,
    hasSavedCard,
  } = useSavedCards();

  const [isPaymentWithSavedCard, setIsPaymentWithSavedCard] = useState(false);

  useEffect(() => {
    setIsPaymentWithSavedCard(hasSavedCard);
  }, [hasSavedCard]);

  const togglePaymentWithSavedCard = () => {
    setIsPaymentWithSavedCard(!isPaymentWithSavedCard);
  };

  if (isLoadingStripeLib || loadingSavedCard) {
    return (
      <div className="flex justify-center w-full">
        <Loader size={36} />
      </div>
    );
  }

  if (isPaymentWithSavedCard) {
    return (
      <PaymentWithSavedCard
        savedCards={savedCards}
        symbol={symbol}
        quotas={quotas}
        selectedQuotaNumber={selectedQuotaNumber}
        setSelectedQuotaNumber={setSelectedQuotaNumber}
        togglePaymentWithSavedCard={togglePaymentWithSavedCard}
      />
    );
  }

  // TODO: El componente CheckoutForm no tiene definido las propTypes
  return (
    <CheckoutForm
      // @ts-expect-error
      symbol={symbol}
      quotas={quotas}
      selectedQuotaNumber={selectedQuotaNumber}
      setSelectedQuotaNumber={setSelectedQuotaNumber}
      isDesktop={isDesktop}
      isStripeMexico={isStripeMexico}
      togglePaymentWithSavedCard={togglePaymentWithSavedCard}
      hasSavedCard={hasSavedCard}
    />
  );
};

export default Stripe;
